<template>
  <div v-if="modalIsOpened" class="fixed inset-0 w-full bg-black/30 z-50">
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[1000px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div
          class="w-full min-h-[280px] mx-auto box-effect rounded-[10px] bg-white overflow-hidden modal-overscroll"
        >
          <header class="w-full py-3 pl-5 pr-2.5 bg-primary">
            <div class="w-full flex justify-between items-center">
              <span class="PC_Body2-R text-[#FCFCFC]">
                อัปเดตข้อมูลสาธารณประโยชน์ที่ได้รับความเสียหาย
              </span>
            </div>
          </header>
          <section
            class="p-[20px] overflow-y-auto max-h-[calc(752px-48px)] scrollbar-custom"
          >
            <div class="flex flex-col gap-[16px]">
              <div
                class="flex items-center gap-[14px] flex-wrap sm:flex-nowrap"
              >
                <SelectBoxComponent
                  :inputId="'damagedUtilities'"
                  :keyValue="'id'"
                  :keyName="'name'"
                  :value="form.type"
                  :options="damagedUtilities"
                  :label="'ประเภทสาธารณประโยชน์ที่ได้รับความเสียหาย'"
                  :placeholder="'เลือกประเภทสาธารณประโยชน์ที่ได้รับความเสียหาย'"
                  :warningMessage="errors.type"
                  @update:modelValue="
                    (res) => {
                      form.type = res;
                    }
                  "
                />
                <Input
                  label="ชื่อสถานที่"
                  placeholder="ชื่อสถานที่"
                  v-model="form.name"
                  :warningMessage="errors.name"
                />
              </div>
              <div>
                <Input
                  label="หมายเลขติดต่อฉุกเฉิน"
                  placeholder="กรอกตัวเลข"
                  v-model="form.phone"
                  :warningMessage="errors.phone"
                  inputType="text"
                  digitsOnly
                  :digitsMaxLength="10"
                />
              </div>

              <div
                class="w-full grid grid-cols-1 sm:grid-cols-3 items-start gap-[16px]"
              >
                <div class="label sm:col-span-3">รายละเอียดที่ตั้ง</div>
                <SelectBoxComponent
                  :inputId="'provinceSelector'"
                  :searchable="true"
                  :allowEmpty="true"
                  :keyValue="'provinceCode'"
                  :keyName="'provinceNameTh'"
                  :value="form.province_code"
                  :placeholder="'เลือกจังหวัด'"
                  :warningMessage="errors.province_code"
                  @update:modelValue="
                    (res) => {
                      form.province_code = res;
                      form.district_code = '';
                      form.subdistrict_code = '';
                      form.postal_code = '';
                      form.geography_id = '';
                    }
                  "
                />
                <SelectBoxComponent
                  :inputId="'districtSelector'"
                  :searchable="true"
                  :allowEmpty="true"
                  :keyValue="'districtCode'"
                  :keyName="'districtNameTh'"
                  :value="form.district_code"
                  :provinceCode="form.province_code"
                  :placeholder="'เลือก เขต/อำเภอ'"
                  :warningMessage="errors.district_code"
                  @update:modelValue="
                    (res) => {
                      form.district_code = res;
                      form.subdistrict_code = '';
                      form.postal_code = '';
                      form.geography_id = '';
                    }
                  "
                />
                <SelectBoxComponent
                  :searchable="true"
                  :allowEmpty="true"
                  :inputId="'subDistrictSelectorP'"
                  :keyValue="'subdistrictCode'"
                  :keyName="'subdistrictNameTh'"
                  :value="form.subdistrict_code"
                  :districtCode="form.district_code"
                  :placeholder="'เลือก แขวง/ตำบล'"
                  :warningMessage="errors.subdistrict_code"
                  :allData="true"
                  @update:modelValue="
                    (res) => {
                      if (res && res.subdistrictCode) {
                        form.subdistrict_code = res.subdistrictCode;
                        form.postal_code = res.postalCode;
                        form.geography_id = res.id;
                      }
                    }
                  "
                />
                <Input
                  placeholder="รหัสไปรษณีย์"
                  v-model="form.postal_code"
                  :warningMessage="errors.postal_code"
                  :disabled="true"
                />
                <div class="sm:col-span-2">
                  <AutoCompleteInput
                    id="address"
                    placeholder="บ้านเลขที่, หมู่ที่, ซอย, และข้อมูลอื่นๆ"
                    v-model="form.address"
                    :fetcher="fetchAddress"
                    :itemText="
                      (it) => (typeof it === 'string' ? it : it?.name ?? '')
                    "
                    :itemValue="
                      (it) => (typeof it === 'string' ? it : it?.name ?? '')
                    "
                    notFoundText="ไม่พบข้อมูล"
                    @select="onPickAddress"
                  />
                </div>
              </div>
              <!-- <div class="flex justify-end gap-[10px]">
              <button
                type="button"
                class="h-[50px] w-[150px] border border-[#B7B2B5] text-[#1F1D1F] M bg-[#fff] rounded-[6px] disabled:bg-[#DFDCDD] disabled:text-[#B7B2B5] cursor-pointer"
                @click="closeModal()"
              >
                ยกเลิก
              </button>
              <button
                type="button"
                class="h-[50px] w-[150px] text-white M bg-[#9B237B] rounded-[6px] disabled:bg-[#DFDCDD] disabled:text-[#B7B2B5]"
                :disabled="hasEmptyItem"
                @click="submit()"
              >
                บันทึก
              </button>
            </div> -->
              <div class="w-full flex justify-end items-center gap-[10px]">
                <ButtonComponent
                  :label="'ยกเลิก'"
                  :bClass="'btn_shadow--cancel'"
                  @clicked="closeModal"
                />
                <ButtonComponent
                  :label="'บันทึก'"
                  :bClass="'btn_shadow--save'"
                  :disabled="hasEmptyItem"
                  @clicked="submit"
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, inject, reactive, nextTick } from "vue";
import axios from "axios";
import { useGlobals } from "@/components/Utilities/javascripts/useGlobals";

import { useShelterStore } from "@/pinia/shelter";
const shelterStore = useShelterStore();

const modalIsOpened = ref(false);
const paginationInfo = ref({});
const emit = defineEmits(["close"]);
const statusModal = inject("statusModal");
const data = ref({});
const isEdit = ref(false);

// const listData = ref([
//     { type:"", name: "" }
// ]);
const listData = ref([]);

const { $validateMsg, $buildFormData } = useGlobals();
const damagedUtilities = ref([]);

let input = {
  type: "",
  name: "",
  phone: "",
  //address
  province_code: "",
  district_code: "",
  subdistrict_code: "",
  postal_code: "",
  address: "",
  geography_id: "",
};
const form = reactive({
  ...input,
});
const errors = ref({
  ...input,
});
const filter = ref({
  paginate: 9999,
  page: "",
  search: "",
});

const defaultForm = {
  type: "",
  name: "",
  phone: "",
  province_code: "",
  district_code: "",
  subdistrict_code: "",
  postal_code: "",
  address: "",
  geography_id: "",
};
const resetForm = (datadm) => {
  Object.assign(form, defaultForm);
  errors.value = {};
  listData.value = [];
  isEdit.value = false;
};

const withIndex = (arr) => arr.map((x, i) => ({ ...x, idx: i }));
const reindex = () => listData.value.forEach((x, i) => (x.idx = i));

const openModal = (datadm, dataEdit) => {
  document.body.style.overflow = "hidden";
  document.body.style.position = "fixed";
  document.body.style.width = "100%";
  damagedUtilities.value = datadm;

  console.log("datadm :: ", datadm);
  console.log("dataEdit :: ", dataEdit);

  if (dataEdit) {
    isEdit.value = true;
    input.id = "";
    Object.assign(form, { ...input, ...dataEdit });
    console.log(form);
  } else {
    resetForm();
  }

  // axios
  //     .get("/damaged-utilities/" + datadm.id, { params: filter.value })
  //     .then((res) => {
  //         if (res.data.success) {
  //             if (res.data.data.data.length > 0) {
  //                 // listData.value = res.data.data.data
  //                 const rows = res.data.data.data.map(x => ({
  //                     type: x.type ?? datadm.id,
  //                     name: (x.name ?? '').toString()
  //                 }))
  //                 listData.value = withIndex(rows)

  //             } else {
  //                 handleAdd()
  //             }
  //         } else {
  //             handleAdd()
  //         }
  //         // paginationInfo.value = res.data;
  //         // damagedUtilities.value = res.data.data;
  //     })
  //     .catch((err) => {
  //         handleAdd()
  //         console.log(err);
  //     });
  modalIsOpened.value = true;
};

const closeModal = (newData) => {
  document.body.style.overflow = "";
  document.body.style.position = "";
  document.body.style.width = "";
  errors.value = {};
  listData.value = [];
  modalIsOpened.value = false;
  if (newData) {
    if (isEdit.value) {
      emit("close", { type: form.type, edit: true, newData: newData });
    } else {
      // emit('close')
      emit("close", { type: form.type, edit: false });
    }
  } else if (isEdit.value) {
    emit("close", { type: form.type, edit: true });
  }
};

const handleRemove = (index) => {
  if (listData.value.length === 1) {
    listData.value[index].name = "";
    delete errors.value[`data.${index}.name`];
  } else {
    listData.value.splice(index, 1);
    shiftErrorsAfterRemove(index);
    reindex();
  }
};

const shiftErrorsAfterRemove = (removedIdx) => {
  const next = {};
  for (const [k, v] of Object.entries(errors.value)) {
    const m = k.match(/^data\.(\d+)\.(.+)$/);
    if (!m) {
      next[k] = v;
      continue;
    }
    const oldIdx = Number(m[1]);
    const field = m[2];
    if (oldIdx === removedIdx) continue; // ทิ้ง error ของแถวที่ลบ
    const newIdx = oldIdx > removedIdx ? oldIdx - 1 : oldIdx;
    next[`data.${newIdx}.${field}`] = v;
  }
  errors.value = next;
};
const submit = () => {
  errors.value = {};
  console.log("form : ", form);
  let api_ac = "";
  if (isEdit.value) {
    api_ac = "/damaged-utility/" + form.id;
  } else {
    api_ac = "/damaged-utility";
  }
  axios
    .post(api_ac, form)
    .then((res) => {
      if (res.data.code == 200) {
        statusModal.value.openModal("success", {
          header: "ดำเนินการสำเร็จ !",
          subHeader: res.data.message,
          closeButtonText: "ปิดหน้าต่าง",
          timeout: 5000,
        });
        // if (isEdit.value) {
        //     emit('close', { type: form.type, edit: true ,newData:res.data})
        // }
        closeModal(res.data);
      } else {
        if (typeof response.data.errors == "string") {
          statusModal.value.openModal("error", {
            header: "ดำเนินการไม่สำเร็จ !",
            subHeader: response.data.errors,
            closeButtonText: "ปิดหน้าต่าง",
          });
        } else {
          $validateMsg(response.data.errors, errors.value);
        }
        // statusModal.value.openModal("error", {
        //     header: "ดำเนินการไม่สำเร็จ !",
        //     subHeader: res.data.message,
        //     closeButtonText: "ปิดหน้าต่าง",
        // });
      }
    })
    .catch((err) => {
      console.log(err);
      if (typeof err.response.data.errors == "string") {
        statusModal.value.openModal("error", {
          header: "ดำเนินการไม่สำเร็จ !",
          subHeader: err.response.data.errors,
          closeButtonText: "ปิดหน้าต่าง",
        });
      } else {
        $validateMsg(err.response.data.errors, errors.value);
      }
    });
};

const getCloseIconClass = (index) => {
  const name = (listData.value[index]?.name ?? "").toString();
  const isEmpty = name.trim() === "";
  return [
    "w-6 h-6 bg-white rounded-full absolute right-[10px] top-1/2 transform -translate-y-1/2",
    !isEmpty
      ? "text-[#EB5554] cursor-pointer"
      : "text-gray-400 cursor-not-allowed",
  ];
};
const hasEmptyItem = computed(() => {
  return Object.values(form).some((value) => {
    // เช็คว่าค่าเป็น string ว่าง, null, undefined หรือ ""
    if (typeof value === "string") {
      return value.trim() === "";
    }
    return value === null || value === undefined;
  });
});

const handleSave = () => {
  console.log("ข้อมูลที่กรอก:", listData.value);
  console.log("ข้อมูล data ที่ผูกมา:", data.value);
};

// ---------------autoComplete---------------
function normalizeAutoComplete(res) {
  if (Array.isArray(res)) return res;
  const arr = res?.data?.data?.data ?? res?.data?.data ?? [];
  return Array.isArray(arr) ? arr : [];
}

const fetchAddress = async ({ query, offset }) => {
  await nextTick();
  const q = typeof query === "string" ? query : "";
  const res = await shelterStore.autoCompleteAddress({
    search: q,
    offset: offset ?? 0,
  });
  return normalizeAutoComplete(res);
};

function onPickAddress(_item) {
  /* ถ้าต้องทำอย่างอื่นเพิ่ม ใส่ตรงนี้ */
}

defineExpose({
  openModal,
  closeModal,
});
</script>

<style lang="scss" scoped>
.label {
  color: #1f1d1f;
  /* fields/title */
  font-family: Kanit;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.1px;
}
</style>